import React, { useEffect, useState, useRef } from "react";
import ReactFC from "react-fusioncharts";

import FusionCharts from "fusioncharts";
import FusionMaps from "fusioncharts/fusioncharts.maps";

import DataCol from "./dataCol";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import "./MapsInicial.css";

// Importa todos los mapas de los departamentos
import ColombiaMap from "fusioncharts/maps/fusioncharts.colombia";
import AntioquiaMap from "fusioncharts/maps/fusioncharts.antioquia";
import AraucaMap from "fusioncharts/maps/fusioncharts.arauca";
import AtlanticoMap from "fusioncharts/maps/fusioncharts.atlantico";
import BolivarMap from "fusioncharts/maps/fusioncharts.bolivar";
import BoyacaMap from "fusioncharts/maps/fusioncharts.boyaca";
import CaldasMap from "fusioncharts/maps/fusioncharts.caldas";
import CaquetaMap from "fusioncharts/maps/fusioncharts.caqueta";
import CasanareMap from "fusioncharts/maps/fusioncharts.casanare";
import CaucaMap from "fusioncharts/maps/fusioncharts.cauca";
import CesarMap from "fusioncharts/maps/fusioncharts.cesar";
import ChocoMap from "fusioncharts/maps/fusioncharts.choco";
import CordobaMap from "fusioncharts/maps/fusioncharts.cordoba";
import CundinamarcaMap from "fusioncharts/maps/fusioncharts.cundinamarca";
import GuainiaMap from "fusioncharts/maps/fusioncharts.guainia";
import GuaviareMap from "fusioncharts/maps/fusioncharts.guaviare";
import GuajiraMap from "fusioncharts/maps/fusioncharts.laguajira";
import HuilaMap from "fusioncharts/maps/fusioncharts.huila";
import LaGuajiraMap from "fusioncharts/maps/fusioncharts.laguajira";
import MagdalenaMap from "fusioncharts/maps/fusioncharts.magdalena";
import MetaMap from "fusioncharts/maps/fusioncharts.meta";
import NarinoMap from "fusioncharts/maps/fusioncharts.narino";
import NorteDeSantanderMap from "fusioncharts/maps/fusioncharts.nortedesantander";
import PutumayoMap from "fusioncharts/maps/fusioncharts.putumayo";
import QuindioMap from "fusioncharts/maps/fusioncharts.quindio";
import RisaraldaMap from "fusioncharts/maps/fusioncharts.risaralda";
import SanAndresMap from "fusioncharts/maps/fusioncharts.sanandresprovidenciaandsantacatalina";
import SantanderMap from "fusioncharts/maps/fusioncharts.santander";
import SucreMap from "fusioncharts/maps/fusioncharts.sucre";
import TolimaMap from "fusioncharts/maps/fusioncharts.tolima";
import ValleDelCaucaMap from "fusioncharts/maps/fusioncharts.valledelcauca";
import VaupesMap from "fusioncharts/maps/fusioncharts.vaupes";
import VichadaMap from "fusioncharts/maps/fusioncharts.vichada";
import AmazonasMap from "fusioncharts/maps/fusioncharts.amazonas";
import { getMapColombiaSostenibilidad } from "../../services/maps/getMapColombiaSostenibilidad";
import { getMapSostenibilidadDepartment } from "../../services/maps/getMapSostenibilidadDepartment";

// Registra todos los mapas necesarios
ReactFC.fcRoot(
  FusionCharts,
  FusionMaps,
  ColombiaMap,
  AntioquiaMap,
  AraucaMap,
  AtlanticoMap,
  BolivarMap,
  BoyacaMap,
  CaldasMap,
  CaquetaMap,
  CasanareMap,
  CaucaMap,
  CesarMap,
  ChocoMap,
  CordobaMap,
  CundinamarcaMap,
  GuainiaMap,
  GuaviareMap,
  GuajiraMap,
  HuilaMap,
  LaGuajiraMap,
  MagdalenaMap,
  MetaMap,
  NarinoMap,
  NorteDeSantanderMap,
  PutumayoMap,
  QuindioMap,
  RisaraldaMap,
  SanAndresMap,
  SantanderMap,
  SucreMap,
  TolimaMap,
  ValleDelCaucaMap,
  VaupesMap,
  AmazonasMap,
  VichadaMap,
  FusionTheme
);

const ColombiaMapSostenibilidadComponent = () => {
  const [mapData, setMapData] = useState(null);
  const [error, setError] = useState(null);
  const [currentMapType, setCurrentMapType] = useState("maps/colombia");
  const [currentDepartmentId, setCurrentDepartmentId] = useState(null);
  const [idMap, setIdMap] = useState({});
  const [nameMap, setNameMap] = useState({});
  const [showBackButton, setShowBackButton] = useState(false);
  const [titleDepto, setTitleDepto] = useState("");
  const [displayedInfo, setDisplayedInfo] = useState(
    "Mueve el cursor sobre un departamento para ver los detalles aquí."
  );
  const [showInfoDiv, setShowInfoDiv] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  const idMapRef = useRef({});
  const nameMapRef = useRef({});
  const currentDataRef = useRef([]);

  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipText, setTooltipText] = useState("");
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  // Flag para controlar el hover durante el click
  const isClickingRef = useRef(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setTooltipPosition({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const handleBackButtonClick = () => {
    setCurrentMapType("maps/colombia");
    setShowInfoDiv(false);
    setDisplayedInfo(
      "Mueve el cursor sobre un departamento para ver los detalles aquí."
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result;
        if (currentMapType === "maps/colombia") {
          result = await getMapColombiaSostenibilidad();

          console.log("Map data for Colombia:", result);

          const newIdMap = result.data.data.reduce((map, item) => {
            map[item.id] = item.idCodInterno;
            return map;
          }, {});

          const newNameMap = result.data.data.reduce((map, item) => {
            map[item.id] = item.nameFusion;
            return map;
          }, {});

          idMapRef.current = newIdMap;
          nameMapRef.current = newNameMap;

          setCurrentDepartmentId(null);
          setShowBackButton(false);
          setTitleDepto("");

          // Actualizar el ref con los datos de Colombia
          currentDataRef.current = result.data.data;
        } else {
          result = await getMapSostenibilidadDepartment(currentDepartmentId);
          setShowBackButton(true);

          // Actualizar el ref con los datos de los municipios
          currentDataRef.current = result.data.data;
        }

        setMapData({
          type: currentMapType,
          renderAt: "map",
          width: "100%",
          height: "600",
          dataFormat: "json",
          dataSource: {
            chart: {
              caption: "UTF COL 166 - COL",
              subcaption: "Proyectos por Departamento",
              theme: "fusion",
              bgColor: "#dee3eb",
              showLabels: "0",
              showlegend: "0",
              borderColor: "#042956",
              borderThickness: "1",
              hoverBorderColor: "#4275af",
              hoverBorderThickness: "1",
              toolTipBorderColor: "#042956",
              toolTipBorderThickness: "1",
              entityFillHoverColor: "#fbc02d",
              entityBorderHoverColor: "#042956",
              toolTipPosition: "bottom",
              animation: "0",
              showToolTip: "0",
              marginTop: "150",
            },
            data: result.data.data,
          },
          events: {
            entityRollover: (evt, data) => {
              try {
                // No procesar hover si se está haciendo click
                if (isClickingRef.current) {
                  return;
                }

                setIsHovering(true);
                const entityData = currentDataRef.current.find(
                  (item) => item.id === data.id
                );

                // Mostrar detalle actual
                if (entityData && entityData.detalleText) {
                  setDisplayedInfo(entityData.detalleText);
                }

                // Mostrar tooltip con el nombre
                const textoTooltip =
                  entityData?.municipio ||
                  entityData?.departamento ||
                  data.label;
                setTooltipText(textoTooltip);
                setShowTooltip(true);

                setShowInfoDiv(true);
              } catch (error) {
                console.error("Error in entityRollover:", error);
              }
            },
            entityRollout: (evt, data) => {
              try {
                setIsHovering(false);
                setShowTooltip(false);

                if (currentMapType === "maps/colombia") {
                  setShowInfoDiv(false);
                }
              } catch (error) {
                console.error("Error in entityRollout:", error);
              }
            },
            entityClick: (eventObj, dataObj) => {
              try {
                // Activar flag de clicking
                isClickingRef.current = true;

                // Desactivar después de un breve delay
                setTimeout(() => {
                  isClickingRef.current = false;
                }, 300);
                handleEntityClick(eventObj, dataObj);
              } catch (error) {
                console.error("Error in entityClick:", error);
              }
            },
          },
        });
      } catch (error) {
        setError("No se pudo cargar la información del mapa");
      }
    };

    fetchData();
  }, [currentMapType, currentDepartmentId]);

  const handleEntityClick = (eventObj, dataObj) => {
    // Si estamos en el mapa de Colombia, navegar al departamento
    if (currentMapType === "maps/colombia") {
      const departmentId = idMapRef.current[dataObj.id];
      const deptoName = nameMapRef.current[dataObj.id];

      if (departmentId && deptoName) {
        // Obtener la información del departamento antes de cambiar
        const deptoData = currentDataRef.current.find(
          (item) => item.id === dataObj.id
        );

        if (deptoData && deptoData.detalleText) {
          setDisplayedInfo(deptoData.detalleText);
          setShowInfoDiv(true);
        }

        setCurrentDepartmentId(departmentId);
        const mapName = `maps/${deptoName}`;
        setCurrentMapType(mapName);
        setTitleDepto(deptoName.toLowerCase());
        setShowBackButton(true);
      }
    } else {
      // Si estamos en un mapa de departamento, mostrar info del municipio clickeado
      const municipioData = currentDataRef.current.find(
        (item) => item.id === dataObj.originalId
      );

      if (municipioData) {
        if (municipioData.detalleText) {
          setDisplayedInfo(municipioData.detalleText);
          setShowInfoDiv(true);
          setIsHovering(false);
        } else {
          // Crear información básica si no existe detalleText
          const basicInfo = `
            <div style="font-family: Arial, sans-serif; font-size: 14px;">
              <div class="container my-2">
                <div class="row">
                  <div class="col-12 bg-light text-primary font-weight-bold text-center py-3 border-secondary"
                      style="font-size: 24px; color: #4CAF50 !important;">
                      ${municipioData.label || "Municipio"}
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <div class="bg-light p-3 border rounded">
                    <h5 style="font-size: 18px; color: #4CAF50 !important;">Información</h5>
                    <p>Código: ${municipioData.id || "-"}</p>
                    <p>Departamento: ${municipioData.nombreDepto || "-"}</p>
                    <p>Valor: ${municipioData.value || "-"}</p>
                  </div>
                </div>
              </div>
            </div>
          `;
          setDisplayedInfo(basicInfo);
          setShowInfoDiv(true);
          setIsHovering(false);
        }
      } else {
        console.log("Municipality not found in data");
      }
    }
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  return (
    <div
      className="container-fluid"
      style={{ display: "flex", height: "100vh" }}
    >
      {showBackButton && (
        <button onClick={handleBackButtonClick} className="back-button">
          Volver
        </button>
      )}

      <div className="row" style={{ flex: 1, display: "flex" }}>
        <div
          className="col-md-6"
          style={{ overflowY: "auto", maxHeight: "100vh" }}
        >
          {showInfoDiv ? (
            <div
              id="infoDiv"
              dangerouslySetInnerHTML={{ __html: displayedInfo }}
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                height: "auto",
              }}
            />
          ) : (
            <DataCol modulo="SOSTENIBILIDAD" layout="default" />
          )}
        </div>
        <div
          className="col-md-6"
          style={{ position: "sticky", top: 0, height: "100vh" }}
        >
          <div id="map" style={{ height: "100%" }}>
            <div className="header-container-depto">
              {titleDepto && (
                <h3 className="header-title">
                  {" "}
                  Departamento | {capitalizeFirstLetter(titleDepto)}
                </h3>
              )}
            </div>
            {mapData?.dataSource?.data?.length ? (
              <ReactFC {...mapData} />
            ) : (
              <p>Cargando mapa...</p>
            )}
          </div>
          {showTooltip && (
            <div
              style={{
                position: "fixed",
                top: tooltipPosition.y + 10,
                left: tooltipPosition.x + 10,
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                color: "#fff",
                padding: "6px 10px",
                borderRadius: "6px",
                fontSize: "13px",
                pointerEvents: "none",
                zIndex: 1000,
                whiteSpace: "nowrap",
              }}
            >
              {tooltipText}
            </div>
          )}
        </div>
      </div>

      <div
        id="fixed-tooltip"
        style={{ position: "absolute", pointerEvents: "none" }}
      ></div>
    </div>
  );
};

export default ColombiaMapSostenibilidadComponent;
